export const Permission = {
  UserAdministration: 'administration:user:manage',
  UserRoleAdministration: 'administration:user:role:manage',
  FileCreateAdmin: 'administration:file:create:admin',
  UpdateNotificationSettings: 'communication:notification:update',
  SendMessage: 'communication:send',
  ConfigureTemplate: 'communication:template:configure',
  TemplateAutomation: 'communication:template:automation',
  ViewAllProgramRequirements: 'program:requirements:view',
  DefaultSectionConfigure: 'dashboard:section:default:configure',
  IndividualSectionConfigure: 'dashboard:section:individual:configure',
  ShareSearches: 'records:searches:share',
  CreateEmployeeRecordsBulk: 'records:employee:create:bulk',
  UpdateEmployeeInfoDisplay: 'record:employee:info:display:update',
  EmployeeRecordExport: 'record:employee:record:export',
  ViewEmployeeSPii: 'record:employee:spii:view',
  UpdateEmployeePersonalInfo: 'record:employee:personal-info:update',
  UpdateEmployeeInfoBulk: 'record:employee:info:update:bulk',
  ViewTimeline: 'record:timeline:view',
  OrderIndividualScreening: 'record:screening:order:individual',
  OrderScreeningsBulk: 'record:screening:order:bulk',
  ComplianceRequirementsBulk: 'records:compliance_requirements:update:bulk',
  StatusOverride: 'record:status:override',
  ComplianceDocumentAuditor: 'record:compliance:document:auditor',
  ComplianceDocumentUpload: 'record:compliance:document:upload',
  ConfigureReports: 'reports:configure',
  ExportReports: 'reports:export',
  ExportSearchReports: 'reports:search:export',
  GeneralDocumentUpload: 'documents:general:upload',
  GeneralDocumentDelete: 'documents:general:delete',
  GeneralDocumentViewDownload: 'documents:general:view-download',
  DocumentNoAccess: 'documents:type:no-access',
  DocumentRead: 'documents:type:read',
  DocumentTemplateEdit: 'documentation:edit',
  UserImport: 'administration:user:import'
} as const;

export type PermissionKey = (typeof Permission)[keyof typeof Permission];
